import { Component, OnInit } from '@angular/core';
import { HardCopyConstants } from '../hard-copy/hard-copy.constants';
import { PanelList } from '../shared/models/panel-list';
import { SpeedDialMenu } from '../shared/models/speed-dial-menu';
import { LocationsService } from '../shared/services/locations.service';
import { MyHardCopyConstants } from './my-hard-copy-constants';
import { MyHardCopyService } from './services/my-hard-copy.service';
import { AssignmentGroupSharedDataService } from '../shared/services/assignment-group-shared-data.service';
import { LabelConstants } from '../shared/constants/label-constants';
import { EqmsScopeManagementService } from '../shared/services/eqms-scope-management.service';
import { CommonService } from '../shared/services/common.service';
import { HardCopyActivityService } from '../hard-copy/services/hard-copy-activity.service';

@Component({
  selector: 'app-my-hard-copy',
  templateUrl: './my-hard-copy.component.html',
  styleUrls: ['./my-hard-copy.component.scss'],
})
export class MyHardCopyComponent implements OnInit {
  myHardCopydata: PanelList = {
    lists: [],
    filters: [],
    sort: [],
  };
  topBarTitle: string = MyHardCopyConstants.MyHardCopyTitle;

  storageLocations: any = [];
  ispanelListDataAvailable = true;
  isDeleteModalVisible = false;
  isConfirmationModalVisible = false;
  completeHardcopyActivityId: any = '';
  maxDefaultCopies: any;
  isRemoveActivity: any;
  displayConfirmationDialog = false;
  showLoader: boolean = true;
  speedDialItems!: SpeedDialMenu[];
  isHardCopyActivitySliderOpen:boolean = false;
  dataActivityId:any;
  showRemovedCopiesChange = false;
  documentNumber!: string;
  documentVersion!:string;
  documentStatus!:number;
  isEditHardCopyAvailableForUser:boolean=true;
  showHardCopyActivityModal:boolean = false;
  hardCopyActivityIdForAudit:string='';
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  isMyHardcopyFetchCompleted : boolean = false;
  fileId!: string;
  fileName!: string;
  constructor(
    private myHardCopyService: MyHardCopyService,
    private locationsService: LocationsService,
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private commonService: CommonService,
    private hardCopyActivityService: HardCopyActivityService) {}

  ngOnInit(): void {
    this.loadHardcopyActivityData();
    this.myHardCopydata.lists.title = 'Panel List';
    this.myHardCopyService.OnHardcopyActivityComplted()
    .subscribe((isUpdated:boolean) => this.HardcopyActivityCompleted(isUpdated));
    this.hardCopyActivityService.OnHardcopyActivityCreatedOrEdited()
    .subscribe((isUpdated: boolean) => {
      this.loadHardcopyActivityData()
    });
  }

  HardcopyActivityCompleted(isUpdated: boolean) {    
    if (isUpdated) {
      setTimeout(() => {
        this.loadHardcopyActivityData();
      }, 1000);
      
    }
  }

  loadHardcopyActivityData() {
    this.getHardCopiesForDocument();
  }

  getHardCopiesForDocument() { 
    this.myHardCopyService
      .getMyHardCopyActivities() 
      .subscribe({
        error: (err) => {
          if(err.status === LabelConstants.Forbidden_StatusCode){
            this.errorMessage=err.error.detail;
          }
           this.isScreenAccessible = false
          this.isMyHardcopyFetchCompleted = false;
        },
        next:(serviceData) =>{
            this.isMyHardcopyFetchCompleted = false;
        if (serviceData != null) {
          this.myHardCopydata.lists= this.assignmentGroupSharedDataService.getPanelListDataWithProperty(serviceData, LabelConstants.MyHardCopyDefaultUserLable);
          this.updateStorageLocationData();
          this.updateeQMSScopeData();
        }
      }
      });
    this.myHardCopyService.hardcopyActivityCompleted.next(false);
  }


  addSorting(): void {
    this.myHardCopydata.enableSort = true;
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Activity',
      sortFieldName: 'activity',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Status',
      sortFieldName: 'status',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Assigned Users',
      sortFieldName: 'assignedUserList',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Copies',
      sortFieldName: 'copies',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Removed Copies',
      sortFieldName: 'removedCopies',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'eQMS Scope',
      sortFieldName: 'eQMSScopeDisplayName',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Hardcopy Storage Location',
      sortFieldName: 'hardcopyStorageLocation',
    });
    this.myHardCopydata.sort?.push({
      sortFieldDisplayName: 'Notes',
      sortFieldName: 'notes',
    });
  }
  addFilters(): void {
    this.myHardCopydata.enableFilter = true;
    this.myHardCopydata.filters?.push({
      filterDisplayName: 'Status',
      filterFieldName: 'status',
    });
    this.myHardCopydata.filters?.push({
      filterDisplayName: 'Assigned User',
      filterFieldName: 'assignedUserList',
    });
    this.myHardCopydata.filters?.push({
      filterDisplayName: 'eQMS Scope',
      filterFieldName: 'eQMSScopeDisplayName',
    });
    this.myHardCopydata.filters?.push({
      filterDisplayName: 'Hardcopy Storage Location',
      filterFieldName: 'hardcopyStorageLocation',
    });
  }

  updateStorageLocationData() {
    for (var dataItem of this.myHardCopydata.lists) {
      dataItem.hardcopyStorageLocation = dataItem.storageLocation
    }
  }

  updateeQMSScopeData(){
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
      this.myHardCopydata.lists?.forEach((hardcopyActivity: { eQMSScope: number; eQMSScopeDisplayName: string | undefined; })=>{
          let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => {return e.eQMSScopeId === hardcopyActivity.eQMSScope});
          hardcopyActivity.eQMSScopeDisplayName = eQMSScope[0].eQMSScopeName;
      });
      this.addFilters();
      this.addSorting();
      this.ispanelListDataAvailable = !this.commonService.IsListEmpty(this.myHardCopydata.lists);
      this.showLoader = false;
    });
  }

  openConfirmationModal(
    hardcopyActivityId: any,
    hardcopyActivityStatus: string,
    hardcopyActivityValue: string,
    copies: any
  ) {
    this.completeHardcopyActivityId = hardcopyActivityId;
    this.isConfirmationModalVisible = true;
    this.maxDefaultCopies = copies;
    if (
      hardcopyActivityStatus == 'Pending' &&
      hardcopyActivityValue == 'Remove'
    ) {
      this.isRemoveActivity = true;
    } else {
      this.isRemoveActivity = false;
    }
    this.displayConfirmationDialog = true;
  }

  handleConfirmation(event: any) {
    this.isConfirmationModalVisible = false;
  }
  
  openDocument(documentNumber: string, version: string) {
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  setData(hcData:any):any
  {
      this.speedDialItems = [];
      this.speedDialItems.push(
        {
            tooltipOptions: {
                tooltipLabel: "Audit",
                tooltipPosition: "left",
            },
            icon: 'pi pi-history',
            command: () => {
                this.openHardCopyActivityAuditModal(hcData.hardcopyActivityId);
            }
        }
      );
      if(((hcData?.status === HardCopyConstants.HardCopyActivity_Activity_Status_Scheduled 
        ||  hcData?.status===HardCopyConstants.HardCopyActivity_Activity_Status_Pending)
        ||(hcData?.status===HardCopyConstants.HardCopyActivity_Activity_Status_Done && hcData?.activity === HardCopyConstants.HardCopyActivity_Activity_Activity_Remove)) 
        && hcData?.isEditButtonAvailable)
       {
        this.speedDialItems.push(
          {
            tooltipOptions: {
              tooltipLabel: "Edit",
              tooltipPosition: "left",
            },
            icon: 'pi pi-pencil',
            command: () => {
              this.editHardCopyActivitySlider(hcData.hardcopyActivityId, hcData.status,hcData.documentNumber,hcData.documentVersion);
            }
          }
        );
      }
      if(hcData?.status!==HardCopyConstants.HardCopyActivity_Activity_Status_Done && hcData?.isCompleteButton){
      this.speedDialItems.push(
      {
        tooltipOptions: {
          tooltipLabel: "Confirm",
          tooltipPosition: "bottom",
        },
        icon: 'pi pi-check',
        command: () => {
          this.openConfirmationModal(hcData.hardcopyActivityId, hcData.status, hcData.activity, hcData.copies);
        }
      }
      );
    }

    if(hcData?.status!==HardCopyConstants.HardCopyActivity_ActivityStatus_Pending 
      && hcData?.activity!==HardCopyConstants.HardCopyActivity_Activity_Activity_Print 
       && hcData?.isDownloadButtonAvailable)
    {
      this.speedDialItems.push(
        {
          tooltipOptions: {
            tooltipLabel: "Print",
            tooltipPosition: "bottom",
          },
          icon: 'pi pi-print',
          command: () => {
            this.hardCopyActivityService.getAndDownloadDocumentSourceFile(hcData?.documentNumber, hcData?.documentVersion,hcData?.documentPhase, hcData?.documentIncludesClientSignature);
         }
        }
        );
    }
    return this.speedDialItems;
  }

  closeSliderOnConfiramtion(closeSlider: boolean) {
    this.dataActivityId='';
      this.isHardCopyActivitySliderOpen = !closeSlider;
  }

  editHardCopyActivitySlider(activityId:any,activityStatus:any,docNumber:any,docVersion:any)
  {
    this.documentNumber=docNumber;
    this.documentVersion=docVersion;
    this.dataActivityId=activityId;
    if(activityStatus==HardCopyConstants.HardCopyActivity_Activity_Status_Done)
    {
      this.showRemovedCopiesChange=true;
    }
    else{
      this.showRemovedCopiesChange=false;
    }
    this.isHardCopyActivitySliderOpen = !this.isHardCopyActivitySliderOpen;
  }
  openHardCopyActivitySlider(){
    this.dataActivityId = '';
    this.isHardCopyActivitySliderOpen = !this.isHardCopyActivitySliderOpen;
  }
  openHardCopyActivityAuditModal = (activityId: string) => {
      this.hardCopyActivityIdForAudit = activityId;
      this.showHardCopyActivityModal = true;
  }
  closeHardCopyActivityAuditModal = (isModalOpen: boolean) => {
      this.hardCopyActivityIdForAudit = '';
      this.showHardCopyActivityModal = isModalOpen;
  }
}
